export enum SocketEvents {
	UPDATE_CANVAS = 'update_canvas',
	UPDATE_LIBRARY = 'update_library',
	UPDATE_ITEM = 'update_item'
}

export enum ActorCommands {
	INIT_CANVAS = 'init_canvas',
	INIT_LIBRARY = 'init_library',
	SAVE_ITEM = 'save_item',
	DELETE_ITEM = 'delete_item',
	SAVE_CANVAS = 'save_canvas'
}
